import { resolveComponent as _resolveComponent, vShow as _vShow, createVNode as _createVNode, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-8289ef70"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "content-view"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ContentAlertModal = _resolveComponent("ContentAlertModal")!
  const _component_ContentMain = _resolveComponent("ContentMain")!
  const _component_ContentMenu = _resolveComponent("ContentMenu")!

  return (_ctx.currentContent)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _withDirectives(_createVNode(_component_ContentAlertModal, {
          width: "100%",
          onCloseContentAlertModal: _ctx.onCloseRecommendOnDesktopModal,
          text: "Para uma melhor experiência, recomendamos visualizar este conteúdo no\r\n        computador."
        }, null, 8, ["onCloseContentAlertModal"]), [
          [_vShow, _ctx.showRecommendOnDesktopModal]
        ]),
        _createVNode(_component_ContentMain),
        _createVNode(_component_ContentMenu)
      ]))
    : _createCommentVNode("", true)
}